import { FixedSizeList as List } from 'react-window';

const MenuList = (props) => {
    const { options, children, maxHeight } = props;

    const height = Math.min(maxHeight, options.length * 35);

    return (
        <List height={height} itemCount={children.length} itemSize={35} width="100%">
            {({ index, style }) => <div style={style}>{children[index]}</div>}
        </List>
    );
};

export default MenuList;
